export const SHOW_SEARCH_RESULTS = 'search/SHOW_SEARCH_RESULTS';
export const HIDE_SEARCH_RESULTS = 'search/HIDE_SEARCH_RESULTS';
